import { useEffect } from "react";

const carriesFiles = (e: Event) =>
  Array.from((e as DragEvent).dataTransfer?.types ?? []).includes("Files");

/**
 * UC-5.2: a file dropped anywhere outside a drop zone must never replace the app (and kill
 * running uploads). While an upload runs, leaving the page asks for confirmation.
 */
export function useWindowFileDropGuard(uploadsActive: boolean): void {
  useEffect(() => {
    const block = (e: Event) => {
      if (carriesFiles(e)) e.preventDefault();
    };
    window.addEventListener("dragover", block);
    window.addEventListener("drop", block);
    return () => {
      window.removeEventListener("dragover", block);
      window.removeEventListener("drop", block);
    };
  }, []);

  useEffect(() => {
    if (!uploadsActive) return;
    const warn = (e: Event) => {
      e.preventDefault();
      (e as BeforeUnloadEvent).returnValue = "";
    };
    window.addEventListener("beforeunload", warn);
    return () => window.removeEventListener("beforeunload", warn);
  }, [uploadsActive]);
}
